'use client';
import { motion } from 'motion/react';
import { cn } from '~/style';

export const PageLoader = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'fixed left-0 top-0 flex h-screen w-screen items-center justify-center',
        className,
      )}
    >
      <motion.div
        className="h-10 w-10"
        initial={{ opacity: 0, scale: 0 }}
        animate={{
          opacity: 1,
          scale: 1,
          transition: {
            duration: 0.5,
            type: 'spring',
          },
        }}
      >
        <div className="loader" />
      </motion.div>
    </div>
  );
};
